export const CBOptions = {
  all: "ALL",
  indeterminate: "INDETERMINATE",
};

export const FacetsFields = {
  propertyType: "securedpropertytype",
  topic: "topic",
  geography: "geography",
  interval: "interval",
  language: "language",
  enablesecurity: "enablesecurity",
  year: "year",
  reportType: "reporttype",
  typeREIS: "reistype",
  doc_type: "doc_type"
};

export const SearchOrder = {
  type: "doc_type",
  name: "title",
  interval: "interval",
  published: "publisheddate",
  updated: "modifieddate",
};

export const OrderType = {
  asc: "asc",
  desc: "desc",
};

export const RESEARCH_HEADER_CELLS = [
  {
    id: "doc_type",
    numeric: false,
    disablePadding: true,
    label: "Type",
    width: "10%",
  },
  {
    id: "title",
    numeric: true,
    disablePadding: false,
    label: "Name",
    width: "30%",
  },
  {
    id: "enablesecurity",
    numeric: true,
    disablePadding: false,
    label: "",
    disableSort: true,
    width: "8%",
  },
  { id: "interval", numeric: true, disablePadding: false, label: "Interval" },
  {
    id: "publisheddate",
    numeric: true,
    disablePadding: false,
    label: "Published",
    width: "12%",
  },
  {
    id: "modifieddate",
    numeric: true,
    disablePadding: false,
    label: "Updated",
    width: "12%",
  },
  {
    id: "actions",
    numeric: true,
    disablePadding: false,
    label: "actions",
    disableSort: true,
    width: "10%",
  },
];

export const RESEARCH_MOBILE_SORT = [
  {
    id: "title",
    lbl: "name",
    sortLbl: "nameaz",
    order: "asc",
  },
  {
    id: "title",
    lbl: "name",
    sortLbl: "nameza",
    order: "desc",
  },
  {
    id: "publisheddate",
    lbl: "publisheddate",
    sortLbl: "Publishedno",
    order: "desc",
    isDefault: true,
  },
  {
    id: "publisheddate",
    lbl: "publisheddate",
    sortLbl: "Publishedon",
    order: "asc",
  },

  {
    id: "modifieddate",
    lbl: "modifieddate",
    sortLbl: "updatedlo",
    order: "desc",
  },
  {
    id: "modifieddate",
    lbl: "modifieddate",
    sortLbl: "updatedol",
    order: "asc",
  },
  {
    id: "interval",
    lbl: "interval",
    sortLbl: "intervalol",
    order: "desc",
  },
  {
    id: "interval",
    lbl: "interval",
    sortLbl: "intervallo",
    order: "asc",
  },
];

export const FilterOptionType = {
  range: "RANGE",
  filter: "FILTER",
};
